import CampaignList from 'common/pages/campaign/CampaignList'

export const CampaignAdvList = (props) =>
    <CampaignList {...props} />